import * as React from 'react';
import { ItemEditor } from './ItemEditor';
import { RouteComponentProps } from 'react-router';
import { Layout, LayoutContent, Navigation } from '../../components';
import { MenuItemInput } from './../../globalTypes';
import { MenuItem, Venue, VenueTax } from './types';
// import { CategoryConfig } from './ItemEditor/types';

interface MenuItemFormProps extends Pick<RouteComponentProps<{}>, 'history'> {
  loading: boolean;
  venueId: string;
  categoryId: string;
  menuId: string;
  drinkId?: string;
  data?: {
    item: MenuItem;
    venue: Venue;
  };
  taxes?: VenueTax[];
  error?: Error;
  onSubmit(data: MenuItemInput): void;
}

const MenuItemFormContent: React.FC<MenuItemFormProps> = (props) => {
  const { venueId, menuId, categoryId, drinkId, loading, error, data } = props;

  const goToMenu = () => {
    props.history.push(`/venue/${venueId}/menu/list/${menuId}/category/${categoryId}`);
  };

  if (loading || (error && !data)) {
    return (
      <LayoutContent error={error}>
        <div>Loading...</div>
      </LayoutContent>
    );
  } else {
    return (
      <LayoutContent error={error}>
        <ItemEditor
          onSubmit={props.onSubmit}
          onCancel={goToMenu}
          menuItem={data.item}
          showTaxableSwitch={data.venue.features.includes('taxable')}
          categoryId={Number(props.categoryId)}
          taxes={props.taxes}
          optionLookUpVariables={{
            venueId,
            menuId,
            categoryId,
            itemId: drinkId,
          }}
        />
      </LayoutContent>
    );
  }
};

export const MenuItemForm: React.FC<MenuItemFormProps> = (props) => {
  return (
    <Layout>
      <Navigation />
      <Layout.TopBar>
        <Layout.TopBar.Left>
          <Layout.TopBar.Title>My Menu</Layout.TopBar.Title>
        </Layout.TopBar.Left>
      </Layout.TopBar>
      <MenuItemFormContent {...props} />
    </Layout>
  );
};
